import { render, staticRenderFns } from "./PcPcmClam.vue?vue&type=template&id=469b0808&"
import script from "./PcPcmClam.vue?vue&type=script&lang=js&"
export * from "./PcPcmClam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports